
export function classifySeries(arr) {

  const n = arr.length;
  if (n === 0) return "Vazio";
  if (n === 1) return "Insuficiente";

  // Média e desvio padrão amostral
  const mean = arr.reduce((a, b) => a + b, 0) / n;
  const varSample = arr.reduce((sum, v) => sum + Math.pow(v - mean, 2), 0) / (n - 1);
  const sd = Math.sqrt(varSample) || 0;

  // Últimos dois pontos
  const last = arr[n - 1];
  const prev = arr[n - 2];
  const delta = last - prev;

  // Ratio = magnitude da variação vs volatilidade típica
  const ratio = Math.abs(delta) / (sd || 1);

  // Classificação baseada em intensidade
  if (ratio < 0.3) {
    return "Stable";
  }

  if (delta > 0) {
    if (ratio > 1.5) return "Strong Upward Trend";
    if (ratio > 0.8) return "Moderate Upward Trend";
    return "Weak Upward Trend";
  } else {
    if (ratio > 1.5) return "Strong Downward Trend";
    if (ratio > 0.8) return "Moderate Downward Trend";
    return "Weak Downward Trend";
  }
}
